var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInformSelected(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 20.3438C15.9366 20.3438 20.3438 15.9366 20.3438 10.5C20.3438 5.06345 15.9366 0.65625 10.5 0.65625C5.06345 0.65625 0.65625 5.06345 0.65625 10.5C0.65625 15.9366 5.06345 20.3438 10.5 20.3438Z",
    fill: "url(#paint0_radial_1602_21216)",
    stroke: "url(#paint1_radial_1602_21216)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1416 16.2L12.9559 17.0304C12.3986 17.2709 11.9534 17.454 11.6219 17.5799C11.2901 17.7061 10.9045 17.7689 10.4652 17.7689C9.79056 17.7689 9.26581 17.5882 8.89155 17.2292C8.51729 16.8688 8.3301 16.4121 8.3301 15.8581C8.3301 15.6436 8.34368 15.423 8.37192 15.1982C8.4004 14.9732 8.44567 14.7198 8.50763 14.4365L9.20408 11.7409C9.26604 11.4827 9.31871 11.2382 9.36089 11.0069C9.40367 10.777 9.42428 10.5656 9.42428 10.3752C9.42428 10.0309 9.3591 9.79015 9.22934 9.65477C9.09959 9.51978 8.85199 9.45124 8.4844 9.45124C8.30436 9.45124 8.11931 9.48277 7.9307 9.54375C7.74124 9.605 7.57931 9.66415 7.44336 9.71914L7.6296 8.88809C8.08583 8.68495 8.52193 8.511 8.93909 8.36663C9.35624 8.22186 9.7504 8.14942 10.1232 8.14942C10.7932 8.14942 11.3102 8.32649 11.6733 8.68065C12.0364 9.03506 12.2178 9.4945 12.2178 10.0607C12.2178 10.1778 12.2059 10.3842 12.1803 10.6792C12.1553 10.9748 12.1087 11.2457 12.0408 11.4921L11.3473 14.177C11.2905 14.3926 11.2393 14.6391 11.1949 14.9165C11.149 15.1921 11.1271 15.4027 11.1271 15.5439C11.1271 15.9004 11.1998 16.1438 11.3455 16.2732C11.4923 16.4026 11.7451 16.467 12.1043 16.467C12.2729 16.467 12.4647 16.4343 12.6779 16.37C12.8904 16.3058 13.0455 16.2494 13.1416 16.2ZM13.3175 4.92828C13.3175 5.39605 13.1563 5.79555 12.8323 6.12404C12.5092 6.45369 12.1198 6.61865 11.6642 6.61865C11.2073 6.61865 10.8169 6.45369 10.4901 6.12404C10.1639 5.79542 10.0004 5.39605 10.0004 4.92828C10.0004 4.46141 10.1639 4.06126 10.4901 3.7286C10.8163 3.39647 11.2074 3.23047 11.6642 3.23047C12.1196 3.23047 12.5092 3.39686 12.8323 3.7286C13.1565 4.06126 13.3175 4.46154 13.3175 4.92828Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_1602_21216",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(3.38221 4.29087) rotate(51.6048) scale(20.4823)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8EDAEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#71CBC6"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_1602_21216",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(3.38221 4.29087) rotate(51.6048) scale(20.4823)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8EDAEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#71CBC6"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInformSelected);
export default __webpack_public_path__ + "static/media/inform-selected.8b35b380c6c8822e38ba54446ec2d5c7.svg";
export { ForwardRef as ReactComponent };